<!--
---
--- Company Registration: Custom component for certificat file upload
---
-->
<template>
    <div id="certificateInput">
        <input type="file" id="file-upload" style="display:none" @change="onFileChange">
        <v-text-field name="certificate"
                      :label="$t('attributes.certificate')"
                      @click.native="openFileDialog"
                      prepend-icon='cloud_upload'
                      v-on:keydown = "preventKeyboardInput"
                      v-model='certificateFile'
                      :error-messages="getCertificateErrorMessages()"/>
    </div>
</template>

<script>
    export default {
        name: "my-input-file",

        data: () => ({
            certificateFile: '',
        }),

        props: {
            name: String,
            model: Object,
            certificateIsValid: Boolean,
        },

        methods: {
            openFileDialog() {
                document.getElementById('file-upload').click();
            },

            onFileChange(ev) {
                var file = ev.target.files[0];
                this.certificateFile = file.name;
                var reader = new FileReader();
                reader.onload = e => this.model.certificateString = e.target.result;
                reader.readAsDataURL(file);
            },

            preventKeyboardInput(event) {
                event.preventDefault();
            },

            getCertificateErrorMessages() {
                var result = [];
                if (this.errors) {
                    for (const error of this.errors) {
                        if (error.field == 'certificate') {
                            result.push(error.msg)
                        }
                    }
                }
                if (!this.certificateIsValid) {
                    result.push(this.$t('attributes.invalidCertificate'))
                }
                return result
            }

        },

        $_veeValidate: {
            name() {
                return this.name;
            },
            value() {
                return this.model[this.name];
            }
        },
    }
</script>

